import { isExperienceItem } from 'lib/checkout/checkoutUtils'

export const EXPERIENCE_UPSELL_METADATA = { checkoutExperienceUpsell: true }

export function isExperienceUpsellSequence(value: unknown): value is number {
  return typeof value === 'number' && Number.isSafeInteger(value) && value > 0
}

export function normaliseExperienceUpsellItems(items: Array<App.Checkout.AnyItem>): Array<App.Checkout.AnyItem> {
  let sequence = items.reduce((highest, item) => {
    const value = isExperienceItem(item) ? item.metaData?.checkoutExperienceUpsellSequence : undefined
    return isExperienceUpsellSequence(value) ? Math.max(highest, value) : highest
  }, 0)
  let changed = false
  const normalised = items.map(item => {
    if (!isExperienceItem(item) || item.metaData?.checkoutExperienceUpsell !== true || item.metaData.checkoutExperienceUpsellSequence !== undefined) return item
    changed = true
    sequence += 1
    return { ...item, metaData: { ...item.metaData, checkoutExperienceUpsellSequence: sequence } }
  })
  return changed ? normalised : items
}

export function hasValidExperienceUpsellItems(items: Array<App.Checkout.AnyItem>): boolean {
  const sequences = new Set<number>()
  return items.filter(isExperienceItem).every(item => {
    const marker = item.metaData?.checkoutExperienceUpsell
    const sequence = item.metaData?.checkoutExperienceUpsellSequence
    if (marker === true) {
      if (!isExperienceUpsellSequence(sequence) || sequences.has(sequence)) return false
      sequences.add(sequence)
      return true
    }
    return (marker === undefined || marker === false) && sequence === undefined
  })
}

export function getFirstExperienceUpsell(items: Array<App.Checkout.AnyItem>): App.Checkout.ExperienceItem | undefined {
  if (!hasValidExperienceUpsellItems(items)) return undefined
  let first: App.Checkout.ExperienceItem | undefined
  let firstSequence = Infinity
  for (const item of items) {
    if (!isExperienceItem(item) || item.metaData?.checkoutExperienceUpsell !== true) continue
    const sequence = item.metaData.checkoutExperienceUpsellSequence
    if (isExperienceUpsellSequence(sequence) && sequence < firstSequence) {
      first = item
      firstSequence = sequence
    }
  }
  return first
}

export function getExperienceUpsellReference(views: Array<Pick<App.Checkout.ExperienceItemView, 'experience' | 'totals'>>, useMemberPrice: boolean): App.ExperienceOffer | undefined {
  let reference: Pick<App.Checkout.ExperienceItemView, 'experience' | 'totals'> | undefined
  let highestTotal = -1
  for (const view of views) {
    const total = useMemberPrice && view.totals.memberPrice > 0 ? view.totals.memberPrice : view.totals.price
    if (total > highestTotal) {
      reference = view
      highestTotal = total
    }
  }
  return reference?.experience
}
